module.exports = __webpack_public_path__ + "static/Roboto-Light-7fe3e6c5aabce901ac7a37e239bbf81b.woff";